// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609070434/js/" + chunkId + "." + {"44":"288a5860","225":"cb5b32df","481":"8593f080","486":"6d621819","770":"9c79d579"}[chunkId] + ".0.04375495515129313.chunk.js";
};